import { createSlice } from '@reduxjs/toolkit'
import { saveState } from '../../localStorage'

export const incentiveSearch = createSlice({
  name: 'incentiveSearch',
  initialState: {
    searchInputs: {
        searchTerms: [],
        state: null,
        stateCode: null,
        utility: null,
    },
    searchResults: [],
  },
  reducers: {
    assignSearchTerms: (state, action) => {
      state.searchInputs = action.payload
      saveState("incentiveSearch", state);
    }
  }
})

// Action creators are generated for each case reducer function
export const { assignSearchTerms } = incentiveSearch.actions

export default incentiveSearch.reducer